import React from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {
	categorizeProgram,
	deleteCategorization,
	updateClientSelectable,
	closeProgramSettings,
	selectAllCategories
} from '../programsSlice';
import useCurrentUser from '../../../hooks/useCurrentUser'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Select from 'react-select'

const SettingsEditor = props =>{
	const user = useCurrentUser()
	const dispatch = useDispatch()
	const program = useSelector(state=>(
		state.programs.programs.entities[state.programs.programSettingsEditor.program_id]
	))
	const categories = useSelector(selectAllCategories).filter(c=>Number(c.user_id_Number)===Number(user.user_id_number))
	const show = useSelector(state=>state.programs.programSettingsEditor.show)
	if(!program) return null
	return (
		<Modal centered show={show} onHide={()=>dispatch(closeProgramSettings())}>
			<Modal.Header closeButton>
				{program.programName} Settings
			</Modal.Header>
			<Modal.Body>
				<Form.Check 
					onChange={e=>{
						dispatch(updateClientSelectable({
							program_id:program.programID,
							client_selectable:Number(e.target.checked)
						}))
					}}
					checked={program.isClientSelectable === 1}
					type="checkbox" 
					label="Let clients assign this program to themselves"/>
				<small className="my-1">Categorization</small>
				<table>
					<tbody>
						{categories.map(category=>(
							<tr>
								<td className="p-1">{category.name}:</td>
								<td className="p-1" style={{width:'100%'}}>
									<Select
										isClearable={false}
										value={
											program.categorization.filter(cat=>(
												cat.category_id === category.id
											)).map(cat=>({
												value:cat.option_id,
												label:cat.option_name,
												categorization_id:cat.id,
												option_id:cat.option_id
											}))
										}
										isMulti={true}
										onChange={(value,action)=>{
											if(action.action === 'select-option'){
												dispatch(categorizeProgram({
													option_id:action.option.value,
													category_id:category.id,
													program_id:program.programID
												}))
											}else if(action.action === 'remove-value'){
												dispatch(deleteCategorization({
													categorization_id:action.removedValue.categorization_id,
													program_id:program.programID
												}))
											}else if(action.action === 'clear'){

											}
										}}
										options={category.options.filter(opt=>{
											for (var i = program.categorization.length - 1; i >= 0; i--) {
												if(program.categorization[i].option_id == opt.id){
													return false
												}
											}
											return true
										}).map(opt=>({
											value:opt.id,
											label:opt.name
										}))}/>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</Modal.Body>
		</Modal>
	)
}
export default SettingsEditor